export default __webpack_public_path__ + "static/056-04e13a0f726ab0087fe093f346ad2806.jpg";